'use client';

import { CardsSwiper } from '../components/CardsSwiper/CardsSwiper';
import { HeadingSection } from '../components/HeadingSection/HeadingSection';
import { DiscoverEngageEarnCard } from './DiscoverEngageEarnCard/DiscoverEngageEarnCard';
import { discoverEngageEarnConfig } from './discoverEngageEarnConfig';

export const DiscoverEngageEarnSection = () => (
  <HeadingSection
    title="Discover. Engage. Earn"
    description="Explore the ecosystem and unlock opportunities designed for active, curious Web3 users."
  >
    <CardsSwiper
      items={discoverEngageEarnConfig}
      renderItem={(item) => <DiscoverEngageEarnCard {...item} />}
    />
  </HeadingSection>
);
